import { InvitedBroker } from '../../../../models/InvitedBroker';

export type InvitedBrokerTable = Pick<
  InvitedBroker,
  'firstName' | 'email' | 'isBrokerAccepted'
>;

export type InvitedBrokerTableKeys = Array<keyof InvitedBrokerTable>;

export const TABLE_COLUMNS: InvitedBrokerTableKeys = [
  'firstName',
  'email',
  'isBrokerAccepted',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  firstName: 'name',
  email: 'email',
  isBrokerAccepted: 'accepted',
};
